/**
 * @deprecated Use {@link LocationWithHierarchyTypeCodes} instead
 */
export const TrailerLocationType = {
  Yard: 1,
  Scale: 2,
  Door: 3,
  ParkingArea: 4,
  ParkingSpot: 5,
  Gate: 6,
};

/**
 * @deprecated Use {@link LocationWithHierarchyTypeCodes} instead
 */
export type TrailerLocationType = (typeof TrailerLocationType)[keyof typeof TrailerLocationType];
